export default "/assets/images/mila-valentine-black-white.9faaad34e079db9c.png";